import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["showPrevious", "cache", "escapeHTML", "showPrevious", "transformItems"];
import React from 'react';
import { useInfiniteHits } from 'react-instantsearch-hooks';
import { InfiniteHits as InfiniteHitsUiComponent } from "../ui/InfiniteHits.js";
export function InfiniteHits(_ref) {
  var _ref$showPrevious = _ref.showPrevious,
      shouldShowPrevious = _ref$showPrevious === void 0 ? true : _ref$showPrevious,
      cache = _ref.cache,
      escapeHTML = _ref.escapeHTML,
      userShowPrevious = _ref.showPrevious,
      transformItems = _ref.transformItems,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useInfiniteHits = useInfiniteHits({
    cache: cache,
    escapeHTML: escapeHTML,
    showPrevious: userShowPrevious,
    transformItems: transformItems
  }, {
    $$widgetType: 'ais.infiniteHits'
  }),
      hits = _useInfiniteHits.hits,
      sendEvent = _useInfiniteHits.sendEvent,
      showPrevious = _useInfiniteHits.showPrevious,
      showMore = _useInfiniteHits.showMore,
      isFirstPage = _useInfiniteHits.isFirstPage,
      isLastPage = _useInfiniteHits.isLastPage;

  var uiProps = {
    hits: hits,
    sendEvent: sendEvent,
    onShowPrevious: shouldShowPrevious ? showPrevious : undefined,
    onShowMore: showMore,
    isFirstPage: isFirstPage,
    isLastPage: isLastPage,
    translations: {
      showPrevious: 'Show previous results',
      showMore: 'Show more results'
    }
  };
  return /*#__PURE__*/React.createElement(InfiniteHitsUiComponent, _extends({}, props, uiProps));
}